import React, { useEffect, useState, useRef } from 'react';
import Logo from '../assets/hsulogo.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import cubesat_bw from '../assets/cubesat_bw.svg';
import cubesat_color from '../assets/cubesat_color.svg';
import cansat_color from '../assets/cansat_color.svg';
import cansat_bw from '../assets/cansat_bw.svg';
import { IoIosDownload } from "react-icons/io";
import UserManual from '../utilities/User_Manual.pdf';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import LeafletMap from './LeafletMap';
import Cube from '../components/Cube';
import { Canvas } from '@react-three/fiber';
import { GoSun } from "react-icons/go";
import { GoMoon } from "react-icons/go";
import { LuHdmiPort } from "react-icons/lu";
import Logo_dark from '../assets/Logo_black_hsu.png'

const Home = () => {

  const [selectCubesat, setSelectCubesat] = useState(false);
  const [isDark, setIsDark] = useState(true);
  const [selectCansat, setSelectCansat] = useState(false);
  const [isHoveredCan, setIsHoveredCan] = useState(false);
  const [isHoveredCube, setIsHoveredCube] = useState(false);
  const [port, setPort] = useState(null);
  const [reader, setReader] = useState(null)
  const targetRef = useRef(null);
  const [sensorDataQueue, setSensorDataQueue] = useState({
    temperature: [],
    pressure: [],
    altitude: [],
    accelerationX: [],
    accelerationY: [],
    accelerationZ: [],
    gyroX: [],
    gyroY: [],
    gyroZ: [],
    latitude: [],
    longitude: [],
    humidity: [],
    battery: [],
    current: [],
    magneticX: [],
    magneticY: [],
    magneticZ: [],
    uv: []
});
const [time, setTime] = useState(0);
const now = new Date();
const formattedDate = now.toLocaleDateString();
const formattedTime = now.toLocaleTimeString();

useEffect(() => {
    // Increment the time counter when new data is added
    if (sensorDataQueue.temperature.length > 0) {
        setTime((prevTime) => prevTime + 1);
    }
}, [sensorDataQueue.temperature]);

const disconnectPort = async () => {
    try {
        if (reader) {
            await reader.cancel(); // Cancel any ongoing read operation
            reader.releaseLock(); // Release the reader lock
            setReader(null); // Clear the reader state
        }
        if (port) {
            await port.close(); // Close the serial port
            setPort(null); // Clear the port state
            toast.success('Disconnected from the port!');
        } else {
            toast.error('No active port to disconnect!');
        }
    } catch (error) {
        console.error('Error disconnecting from the port:', error);
        toast.error('Failed to disconnect from the port.');
    }
};


// Function to update the queue with new data
const updateQueue = (queue, newData) => {
    if (queue.length === 10) {
        queue.shift(); // Remove oldest data if queue is full
    }
    return [...queue, newData]; // Add new data to the end of the queue
};


// Combine acce data for all axes into one dataset
const combinedAccelerationData = sensorDataQueue.accelerationX.map((valueX, index) => ({
    time: time - sensorDataQueue.accelerationX.length + index + 1,
    accelerationX: valueX,
    accelerationY: sensorDataQueue.accelerationY[index],
    accelerationZ: sensorDataQueue.accelerationZ[index]
}));


// Combine gyro data for all axes into one dataset
const combinedGyroData = sensorDataQueue.gyroX.map((valueX, index) => ({
    time: time - sensorDataQueue.gyroX.length + index + 1,
    gyroX: valueX,
    gyroY: sensorDataQueue.gyroY[index],
    gyroZ: sensorDataQueue.gyroZ[index]
}));

//combined magnetic field data for all axes into one dataset
const combinedMagneticFiledData = sensorDataQueue.magneticX.map((valueX, index) => ({
    time: time - sensorDataQueue.magneticX.length + index + 1,
    magneticX: valueX,
    magneticY: sensorDataQueue.magneticY[index],
    magneticZ: sensorDataQueue.magneticZ[index]
}))

// const lastHumidity = sensorDataQueue.humidity[sensorDataQueue.humidity.length - 1];
// const secondLastHumidity = sensorDataQueue.humidity[sensorDataQueue.humidity.length - 2];
// const humidityFluctuation = lastHumidity - secondLastHumidity;

// const lastTemperature = sensorDataQueue.temperature[sensorDataQueue.temperature.length - 1];
// const secondLastTemperature = sensorDataQueue.temperature[sensorDataQueue.temperature.length - 2];
// const temperatureFluctuation = lastTemperature - secondLastTemperature;

// const lastPressure = sensorDataQueue.pressure[sensorDataQueue.pressure.length - 1];
// const secondLastPressure = sensorDataQueue.pressure[sensorDataQueue.pressure.length - 2];
// const pressureFluctuation = lastPressure - secondLastPressure;

// const lastAltitude = sensorDataQueue.altitude[sensorDataQueue.altitude.length - 1];
// const secondLastAltitude = sensorDataQueue.altitude[sensorDataQueue.altitude.length - 2];
// const altitudeFluctuation = lastAltitude - secondLastAltitude;

const downloadSensorData = () => {
    // Initialize CSV content with header
    let csvContent = 'Temperature,Pressure,Altitude,AccelerationX,AccelerationY,AccelerationZ,GyroX,GyroY,GyroZ,Latitude,Longitude,Humidity,Battery,Current,MagneticFieldX,MagneticFieldY,MagneticFieldZ,UV\n';
  
    // Append each data point to the CSV content
    for (let i = 0; i < sensorDataQueue.temperature.length; i++) {
        // Construct the row as a string
        let row = `${sensorDataQueue.temperature[i]},`;
        row += `${sensorDataQueue.pressure[i]},`;
        row += `${sensorDataQueue.altitude[i]},`;
        row += `${sensorDataQueue.accelerationX[i]},`;
        row += `${sensorDataQueue.accelerationY[i]},`;
        row += `${sensorDataQueue.accelerationZ[i]},`;
        row += `${sensorDataQueue.gyroX[i]},`;
        row += `${sensorDataQueue.gyroY[i]},`;
        row += `${sensorDataQueue.gyroZ[i]},`;
        row += `${sensorDataQueue.latitude[i]},`;
        row += `${sensorDataQueue.longitude[i]},`;
        row += `${sensorDataQueue.humidity[i]},`;
        row += `${sensorDataQueue.battery[i]},`;
        row += `${sensorDataQueue.current[i]},`;
        row += `${sensorDataQueue.magneticX[i]},`;
        row += `${sensorDataQueue.magneticY[i]},`;
        row += `${sensorDataQueue.magneticZ[i]},`;
        row += `${sensorDataQueue.uv[i]}`;
        
        // Append the row to the CSV content followed by a newline
        csvContent += row + '\n';
    }
  
    // Create and trigger the download
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `sensor_data_${formattedDate}_${formattedTime}.csv`; // Ensure formattedDate and formattedTime are defined
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};


const handelShowPorts = async () => {
    try {
        if (!selectCansat && !selectCubesat) {
            toast.error('Select a satellite type!');
            return;
        }

        if ("serial" in navigator) {
            const selectedPort = await navigator.serial.requestPort();

            // Check if the user didn't select any port
            if (!selectedPort) {
                toast.error('No port selected!');
                return;
            }

            await selectedPort.open({ baudRate: 9600 });
            setPort(selectedPort); // Save the port in state

            const selectedReader = selectedPort.readable.getReader();
            setReader(selectedReader); // Save the reader in state

            let buffer = '';

            while (true) {
                const { value, done } = await selectedReader.read();
                if (done) {
                    selectedReader.releaseLock();
                    setReader(null); // Clear the reader state
                    break;
                }

                // Append the received data to the buffer
                buffer += new TextDecoder().decode(value);

                // Split the buffer by newline characters to extract complete lines
                const lines = buffer.split('\n');

                // Process all but the last line (it might be incomplete)
                for (let i = 0; i < lines.length - 1; i++) {
                    const line = lines[i];
                    // console.log('Processed line:', line);

                    // Parse the line into sensor values
                    const sensorValues = line.split(',').map((value) => parseFloat(value.trim()));
                    const sensorTypes = [
                        'temperature',
                        'pressure',
                        'altitude',
                        'accelerationX',
                        'accelerationY',
                        'accelerationZ',
                        'gyroX',
                        'gyroY',
                        'gyroZ',
                        'latitude',
                        'longitude',
                        'humidity',
                        'battery',
                        'current',
                        'magneticX',
                        'magneticY',
                        'magneticZ',
                        'uv'
                    ];

                    // Update the sensorDataQueue state with the new data
                    setSensorDataQueue((prevQueue) => {
                        const updatedQueue = { ...prevQueue };
                        sensorTypes.forEach((type, index) => {
                            updatedQueue[type] = updateQueue(prevQueue[type], sensorValues[index]);
                        });

                        if (targetRef.current) {
                            targetRef.current.scrollIntoView({ behavior: 'smooth' });
                        }

                        return updatedQueue;
                    });
                }

                // Keep any remaining partial data in the buffer
                buffer = lines[lines.length - 1];
            }
        } else {
            toast.error('Serial API not supported in this browser.');
        }
    } catch (error) {
        console.error('Error handling ports:', error);
        toast.error('Failed to read data from the port.');
    }
};

  

  const handelCubesatSelect = () => {
    setSelectCansat(false);
    setSelectCubesat(true);
    
  }

  const handelCansatSelect = () => {
    setSelectCubesat(false);
    setSelectCansat(true);
  }

  const handelDownload = () => {
    const link = document.createElement('a');
    link.href = UserManual;

    link.download = 'DashboardUserManual.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  const axisColor = isDark ? '#ffffff' : '#1c1917'; // stone-900 in light
  const gridColor   = isDark ? '#f5f5f5' : '#1c1917'; // light gray in dark, stone-900 in light
  const gridOpacity = isDark ? 0.12 : 0.25;           // a bit stronger in light mode



  return (
<div className={isDark ? "dark" : ""}>
  <div className='h-full flex flex-col justify-center items-center  gap-12 bg-white dark:bg-stone-950 text-stone-900 dark:text-white'>
    <ToastContainer theme={isDark ? 'dark' : 'light'} /> {/* was 'dark' — now dynamic */}

    <div className='flex gap-[70rem] items-center mt-2 absolute top-0 w-full h-18 '>
      <a href="https://hexstaruniverse.com"><img src={isDark ? Logo : Logo_dark} alt="Xexicon" className='mt-4 ml-8 w-[125px] cursor-pointer'/></a>

      {/* RIGHT CONTROLS: toggle + your original button (kept as-is) */}
      <div className='flex items-center gap-3 pr-4'>
        

        <button className='flex justify-center h-8 items-center gap-2 bg-gradient-to-r from-purple-600 to to-blue-600 rounded-sm text-white font-["Aldrich"] capitalize px-4 py-5 hover:bg-purple-70 w-max hover:scale-105' onClick={handelDownload}>
          <IoIosDownload color='white' size={20} />
          user manual
        </button>
      </div>
    </div>

    <div className='flex gap-8 mt-[15vh]'>
      <div
        className={`relative w-[290px] h-[204px] bg-neutral-950 bg-opacity-0 rounded-md border-4 ${selectCubesat ? '!border-purple-600 dark:!border-purple-600' : '!border-stone-900 dark:!border-white'} dark:border-white border-stone-300 flex flex-col justify-center items-center text-xl font-normal font-['Aldrich'] hover:border-purple-600 transition-[0.5s] cursor-pointer text-stone-900 dark:text-white`}
        onMouseEnter={() => setIsHoveredCube(true)}
        onMouseLeave={() => setIsHoveredCube(false)}
        onClick={handelCubesatSelect}
      >
        <img src={!isHoveredCube && !selectCubesat ? cubesat_bw : cubesat_color} alt="Cubesat" className='absolute bottom-[30%] w-[200px]' />
        <p className='absolute top-[80%]'><strong>Cubesat</strong></p>
      </div>

      <div
        className={`relative w-[290px] h-[204px] bg-neutral-950 bg-opacity-0 rounded-md border-4 ${selectCansat ? '!border-purple-600 dark:!border-purple-600' : '!border-stone-900 dark:!border-white'} dark:border-white border-stone-300 flex flex-col justify-center items-center text-xl font-normal font-['Aldrich'] hover:border-purple-600 transition-[0.5s] cursor-pointer text-stone-900 dark:text-white`}
        onMouseEnter={() => setIsHoveredCan(true)}
        onMouseLeave={() => setIsHoveredCan(false)}
        onClick={handelCansatSelect}
      >
        <img src={!isHoveredCan && !selectCansat ? cansat_bw : cansat_color} alt="Cansat" className='absolute bottom-[8%] w-[200px]' />
        <p className='absolute top-[80%]'><strong>Cansat</strong></p>
      </div>
    </div>

    <button className='flex justify-center h-8 items-center gap-2 bg-gradient-to-r from-purple-600 to to-blue-600 rounded-sm text-white font-["Aldrich"] capitalize hover:bg-purple-70 w-max hover:scale-105 px-4 py-5' onClick={handelShowPorts}> <LuHdmiPort /> Select Resouce</button>

    {/* <motion.div className='w-[500px] mt-12' animate={animation}>
      <img src={globe} alt="Earth" />
    </motion.div> */}

    <div className='flex justify-center items-baseline w-full font-["Aldrich"] gap-20 py-20 text-stone-900 dark:text-white'>
      <div className='flex flex-col gap-10' ref={targetRef}>
        <div className='flex flex-col gap-4 text-xs'  id='content'>
          <button className='uppercase bg-gradient-to-r from-purple-600 to to-blue-600 text-white rounded-sm px-3 py-2 hover:bg-purple-700 transition-[0.3s] flex justify-center items-center gap-2' onClick={downloadSensorData}>
            <IoIosDownload color='white' size={18} />
            Download Data
          </button>
          <button className='uppercase bg-red-600 rounded-sm px-3  text-white py-2 hover:bg-red-700 transition-[0.3s]' onClick={disconnectPort}>Disconnect</button>
          <button className='uppercase bg-gradient-to-r from-purple-600 to to-blue-600 rounded-sm px-3 py-2 text-white hover:bg-purple-700 transition-[0.3s]' onClick={() => window.location.href = 'https://wa.link/e1vw9c'}>support</button>
          <button className='uppercase bg-gradient-to-r from-purple-600 to to-blue-600 rounded-sm px-3 py-2 text-white hover:bg-purple-700 transition-[0.3s]' onClick={() => window.location.href = 'https://dashboard.cubesat.in/'}>change version</button>
        </div>

        <div className='text-xs dark:text-white text-stone-900'>
          <ul className='flex flex-col gap-2'>
            <li className='flex gap-2 capitalize'>
              <div className='w-[18px] h-[18px] bg-[#4cfe53] rounded-sm'></div>
              <p>X axis data</p>
            </li>
            <li className='flex gap-2 capitalize'>
              <div className='w-[18px] h-[18px] bg-[#fe4c4c] rounded-sm'></div>
              <p>Y axis data</p>
            </li>
            <li className='flex gap-2 capitalize'>
              <div className='w-[18px] h-[18px] bg-[#0076ff] rounded-sm'></div>
              <p>Z axis data</p>
            </li>
          </ul>
        </div>

        {/* Theme toggle (emoji so no new imports) */}
        <div className='flex justify-start items-center pr-3'>
          <button
          type="button"
          aria-label="Toggle theme"
          aria-pressed={isDark}
          onClick={() => setIsDark(v => !v)}
          className={`flex h-8 items-center justify-center rounded-md gap-2 px-3 whitespace-nowrap hover:scale-105 transition ${isDark ? 'bg-stone-700' : 'bg-stone-300'}`}
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? (
            <GoSun className="text-stone-900 dark:text-yellow-300 text-xl" />
          ) : (
            <GoMoon className="text-stone-600 dark:text-white text-xl" />
          )}
          <span className="text-stone-900 dark:text-white text-xs font-medium">
            {isDark ? 'Light' : 'Dark'}
          </span>
        </button>
        </div>


      </div>

      {/* Display sensor data */}
      <div className='flex flex-col gap-6 mt-7'>
  <div className='flex flex-row gap-12'>
    {/* Temperature Chart */}
    <div className='flex flex-col py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-[10px]'>Temperature</p>
      <LineChart
        width={243}
        height={142}
        data={sensorDataQueue.temperature.map((temp, index) => ({
          time: time - sensorDataQueue.temperature.length + index + 1,
          temperature: temp
        }))}
        margin={{ right: 35, left: 10, top: 12 }}
      >
        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke={axisColor} tick={{ fill: axisColor }} />
        <YAxis label={{ value: "Celcius", angle: -90, position: "insideCenter", dx: -10, fill: axisColor }} domain={[5, 55]} stroke={axisColor} tick={{ fill: axisColor }} />
        <Tooltip contentStyle={{ backgroundColor: '#121212', borderColor: '#6637ed', color: 'white', borderRadius: 2 }} itemStyle={{ color: '#FEF74C' }} />
        <CartesianGrid stroke={gridColor} strokeOpacity={gridOpacity} />
        <Line type='linear' dataKey="temperature" stroke="#FEF74C" strokeWidth={2} />
      </LineChart>
    </div>

    {/* Altitude Chart */}
    <div className='flex flex-col py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-[10px]'>Altitude</p>
      <LineChart
        width={243}
        height={142}
        data={sensorDataQueue.altitude.map((alt, index) => ({
          time: time - sensorDataQueue.altitude.length + index + 1,
          altitude: alt
        }))}
        margin={{ right: 35, left: 10, top: 12 }}
      >
        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke={axisColor} tick={{ fill: axisColor }} />
        <YAxis label={{ value: "Meter(s)", angle: -90, position: "insideCenter", dx: -20, fill: axisColor }} domain={[50, 80]} stroke={axisColor} tick={{ fill: axisColor }} />
        <Tooltip contentStyle={{ backgroundColor: '#121212', borderColor: '#6637ed', color: 'white', borderRadius: 2 }} itemStyle={{ color: '#FF11DF' }} />
        <CartesianGrid stroke={gridColor} strokeOpacity={gridOpacity} />
        <Line type='linear' dataKey="altitude" stroke="#FF11DF" strokeWidth={2} />
      </LineChart>
    </div>

    {/* Atmospheric Pressure Chart */}
    <div className='flex flex-col py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-[10px]'>Atmospheric Pressure</p>
      <LineChart
        width={243}
        height={142}
        data={sensorDataQueue.pressure.map((psi, index) => ({
          time: time - sensorDataQueue.pressure.length + index + 1,
          pressure: psi
        }))}
        margin={{ right: 35, left: 10, top: 12 }}
      >
        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke={axisColor} tick={{ fill: axisColor }} />
        <YAxis label={{ value: "PSI", angle: -90, position: "insideCenter", dx: -20, fill: axisColor }} domain={[1000, 50000]} stroke={axisColor} tick={{ fill: axisColor }} />
        <Tooltip contentStyle={{ backgroundColor: '#121212', borderColor: '#6637ed', color: 'white', borderRadius: 2 }} itemStyle={{ color: '#FEA14C' }} />
        <CartesianGrid stroke={gridColor} strokeOpacity={gridOpacity} />
        <Line type='linear' dataKey="pressure" stroke="#FEA14C" strokeWidth={2} />
      </LineChart>
    </div>

    {/* Humidity */}
    <div className='flex flex-col py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-[10px]'>Humidity</p>
      <LineChart
        width={243}
        height={142}
        data={sensorDataQueue.humidity.map((hum, index) => ({
          time: time - sensorDataQueue.humidity.length + index + 1,
          humidity: hum
        }))}
        margin={{ right: 35, left: 10, top: 12 }}
      >
        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke={axisColor} tick={{ fill: axisColor }} />
        <YAxis label={{ value: "Percentage", angle: -90, position: "insideCenter", dx: -10, fill: axisColor }} domain={[0, 100]} stroke={axisColor} tick={{ fill: axisColor }} />
        <Tooltip contentStyle={{ backgroundColor: '#121212', borderColor: '#6637ed', color: 'white', borderRadius: 2 }} itemStyle={{ color: '#4C84FE' }} />
        <CartesianGrid stroke={gridColor} strokeOpacity={gridOpacity} />
        <Line type='linear' dataKey="humidity" stroke="#4C84FE" strokeWidth={2} />
      </LineChart>
    </div>
  </div>

  <div className='flex flex-row gap-12 mt-4'>
    {/* Acceleration */}
    <div className='flex flex-col py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-[10px]'>Acceleration</p>
      <LineChart
        width={243}
        height={142}
        data={combinedAccelerationData}
        margin={{ right: 35, left: 10, top: 12 }}
      >
        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke={axisColor} tick={{ fill: axisColor }} />
        <YAxis label={{ value: "Acceleration (g)", angle: -90, position: "insideCenter", dx: -20, fill: axisColor }} domain={[0, 10]} stroke={axisColor} tick={{ fill: axisColor }} />
        <Tooltip contentStyle={{ backgroundColor: '#121212', borderColor: '#6637ed', color: 'white', borderRadius: 2 }} itemStyle={{ color: 'white' }} />
        <CartesianGrid stroke={gridColor} strokeOpacity={gridOpacity} />
        <Line type='linear' dataKey="accelerationX" stroke="#4cfe53" strokeWidth={2} />
        <Line type='linear' dataKey="accelerationY" stroke="#fe4c4c" strokeWidth={2} />
        <Line type='linear' dataKey="accelerationZ" stroke="#0076ff" strokeWidth={2} />
      </LineChart>
    </div>

    {/* data telemetry — ONLY border color changed */}
    <div className="flex justify-center items-center w-[534px] rounded-[5px] h-[185px] border py-2 px-1 border-stone-900 dark:border-[#6637ed]">
      {sensorDataQueue.latitude?.length > 0 && sensorDataQueue.longitude?.length > 0 ? (
        <LeafletMap longitudes={sensorDataQueue.longitude} latitudes={sensorDataQueue.latitude} />
      ) : (
        <p className='flex justify-center items-center text-[10px]'>Loading map...</p>
      )}
    </div>

    <div className='flex flex-col py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-[10px]'>Gyro Orientation</p>
      <LineChart
        width={243}
        height={142}
        data={combinedGyroData}
        margin={{ right: 35, left: 10, top: 12 }}
      >
        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke={axisColor} tick={{ fill: axisColor }} />
        <YAxis label={{ value: "Gyro (°/s)", angle: -90, position: "insideCenter", dx: -20, fill: axisColor }} domain={[0, 1]} stroke={axisColor} tick={{ fill: axisColor }} />
        <Tooltip contentStyle={{ backgroundColor: '#121212', borderColor: '#6637ed', color: 'white', borderRadius: 2 }} itemStyle={{ color: 'white' }} />
        <CartesianGrid stroke={gridColor} strokeOpacity={gridOpacity} />
        <Line type='linear' dataKey="gyroX" stroke="#4cfe53" strokeWidth={2} />
        <Line type='linear' dataKey="gyroY" stroke="#fe4c4c" strokeWidth={2} />
        <Line type='linear' dataKey="gyroZ" stroke="#0076ff" strokeWidth={2} />
      </LineChart>
    </div>
  </div>

  <div className='flex flex-row gap-12 mt-4'>
    {/* Battery */}
    <div className='flex flex-col items-center w-[243px] py-4 rounded-[10px] shadow border text-[10px] h-[185px] border-stone-900 dark:border-[#6637ed]'>
      <p className='flex justify-center items-center font-normal text-xl'>Battery</p>
      {/* battery */}
      <div className="flex justify-center items-center pt-8 space-x-2 text-xs text-stone-900 dark:text-white">
        {/* Battery Icon */}
        <div className="relative w-24 h-10 border-2 dark:border-white border-stone-900 rounded-sm flex items-center">
          <div
            className={`h-full transition-all duration-300 ${sensorDataQueue.battery.at(-1) < 3.3 ? 'bg-red-600' : 'bg-green-500'}`}
            style={{
              width: `${Math.min(100, Math.max(0, (sensorDataQueue.battery.at(-1) / 5.7) * 100))}%`,
            }}
          />
          {/* Battery Tip */}
          <div className="absolute -right-2.5 h-4 w-2.5 dark:bg-white bg-stone-900 rounded-sm" />
        </div>

        {/* Percentage Text */}
        <span className='pl-2'>
          {Math.round((sensorDataQueue.battery.at(-1) / 5.7) * 100)}%
        </span>
      </div>
      <span className='text-sm py-3'>({sensorDataQueue.battery.at(-1) ?? 'N/A'}) V</span>
    </div>

    {/* Metrics panel (data div) — no background, border color only */}
    <div className='flex w-[534px] h-[185px] rounded-[5px] border py-2 px-8 text-[10px] justify-center items-center gap-5 border-stone-900 dark:border-[#6637ed]'>
      {/* First Column */}
      <div className='flex-1'>
        <div className='flex flex-col gap-2'>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Temperature:</p>
            <p>{sensorDataQueue.temperature.at(-1) ?? 'N/A'} °C</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Pressure:</p>
            <p>{sensorDataQueue.pressure.at(-1) ?? 'N/A'} hPa</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Altitude:</p>
            <p>{sensorDataQueue.altitude.at(-1) ?? 'N/A'} m</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>aX:</p>
            <p>{sensorDataQueue.accelerationX.at(-1) ?? 'N/A'} g</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>aY:</p>
            <p>{sensorDataQueue.accelerationY.at(-1) ?? 'N/A'} g</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>aZ:</p>
            <p>{sensorDataQueue.accelerationZ.at(-1) ?? 'N/A'} g</p>
          </div>
        </div>
      </div>

      {/* Second Column */}
      <div className='flex-1'>
        <div className='flex flex-col gap-2'>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>gX:</p>
            <p>{sensorDataQueue.gyroX.at(-1) ?? 'N/A'} °/s</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>gY:</p>
            <p>{sensorDataQueue.gyroY.at(-1) ?? 'N/A'} °/s</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>gZ:</p>
            <p>{sensorDataQueue.gyroZ.at(-1) ?? 'N/A'} °/s</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Latitude:</p>
            <p>{sensorDataQueue.latitude.at(-1) ?? 'N/A'} °</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Longitude:</p>
            <p>{sensorDataQueue.longitude.at(-1) ?? 'N/A'} °</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Humidity:</p>
            <p>{sensorDataQueue.humidity.at(-1) ?? 'N/A'} %</p>
          </div>
        </div>
      </div>

      {/* Third Column */}
      <div className='flex-1'>
        <div className='flex flex-col gap-2'>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Battery:</p>
            <p>{sensorDataQueue.battery.at(-1) ?? 'N/A'} V</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>Current:</p>
            <p>{sensorDataQueue.current.at(-1) ?? 'N/A'} A</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>mX:</p>
            <p>{sensorDataQueue.magneticX.at(-1) ?? 'N/A'} µT</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>mY:</p>
            <p>{sensorDataQueue.magneticY.at(-1) ?? 'N/A'} µT</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>mZ:</p>
            <p>{sensorDataQueue.magneticZ.at(-1) ?? 'N/A'} µT</p>
          </div>
          <div className='flex justify-between gap-5'>
            <p className='font-bold'>UV:</p>
            <p>{sensorDataQueue.uv.at(-1) ?? 'N/A'} mW/cm²</p>
          </div>
        </div>
      </div>
    </div>

    <div className="w-[243px] flex items-center justify-center">
      <Canvas camera={{ position: [5, 5, 5], fov: 60, near: 0.1, far: 1000 }}>
        <ambientLight intensity={0.6} />
        <directionalLight position={[5, 5, 5]} intensity={1} color={'#051201'} />
        <Cube sensorDataQueue={sensorDataQueue} />
      </Canvas>
    </div>
  </div>
</div>


</div>

    <div className='flex flex-col dark:text-stone-400 text-stone-900 mb-10 font-["Poppins"] text-[12px] text-center'>
      <span>© {new Date().getFullYear()} Hex-Star Universe | Website developed & designed by <span className='underline'><a href="https://www.hexstaruniverse.com">Hex-Star Universe</a></span></span>
    </div>
  </div>
</div>

  );
}

export default Home;